import {
  Goal,
  GroupByMode,
  ID,
  noGroupingId,
  TaskGroupBy,
} from '@griply/types';

export const buildGoalTaskCustomOrder = (
  groupBy: TaskGroupBy | null | undefined,
  goal: Goal | undefined,
  subGoals: Goal[] = [],
): Record<ID, ID[]> => {
  if (!goal?.id) {
    return {};
  }

  const resolved = ((): Exclude<
    GroupByMode,
    GroupByMode.None | GroupByMode.LifeArea
  > => {
    if (
      !groupBy ||
      groupBy === GroupByMode.None ||
      groupBy === GroupByMode.LifeArea
    ) {
      return GroupByMode.Section;
    }
    return groupBy as Exclude<
      GroupByMode,
      GroupByMode.None | GroupByMode.LifeArea
    >;
  })();

  if (resolved === GroupByMode.Section) {
    const goalSections = goal.sections ?? [];
    return {
      [noGroupingId]: goal.taskSorting ?? [],
      ...goalSections.reduce<Record<ID, ID[]>>((acc, section) => {
        acc[section.id] = section.tasks ?? [];
        return acc;
      }, {}),
    };
  }

  if (resolved === GroupByMode.Goal) {
    return {
      [goal.id]: goal.taskSorting ?? [],
      ...subGoals.reduce<Record<ID, ID[]>>((acc, subGoal) => {
        acc[subGoal.id] = subGoal.taskSorting ?? [];
        return acc;
      }, {}),
    };
  }

  return goal.customTaskOrder?.[resolved] ?? {};
};
